import { defineStore } from 'pinia'
import { ref } from 'vue';
import { authStore } from "../index";
import axios from 'axios';
export const useVideoApiStore = defineStore('videoApi', () => {
// BASEURL MUST BE ATLEAST SANDBOX SO IF IN LOCAL SET IT AS SUCH
    const axiosInstance = () => {
        const auth = authStore();
        const authHeader = `${auth.user.id_token}`;
        const axiosInstance = axios.create({
            withCredentials: true,
            //baseURL: process.env.VUE_APP_BASE_URL, //http://localhost:8080,
            baseURL: 'https://sandbox.hyperlayer.virtualeye.com',
            headers: {
                common: {
                    Authorization: authHeader
                }
            }
        });

        axiosInstance.interceptors.request.use((request) => {
            request.transformResponse = [data => data]
            return request
        });
        axiosInstance.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            return error
        });
        return axiosInstance;
    }

    const handleError = (error: any) => {
        console.error(error);
        return Promise.reject(error);
    }

    const authorize = async () => {
        try {
            const response = await axiosInstance().post('/authorize')
            return response
        } catch (error) {
            return handleError(error);
        }
    }

    const fetchVideo = async (queryUrl:string) => {
        try {
            return await axiosInstance().get(queryUrl);
        } catch (error) {
            return handleError(error);
        }
    };


    return {
        authorize,
        fetchVideo,
    }
});






